import parseBoolean from 'utils/parse-boolean';

const SELECTOR = '[data-dialog]';

export function init() {
    const elements = document.querySelectorAll(SELECTOR);

    for (const element of elements) {
        const selector = element.dataset.dialog;

        if (!selector) {
            continue;
        }

        const dialog = document.querySelector(selector);

        if (!dialog) {
            continue;
        }

        const callback = element.dataset.dialogCallback;

        let modal = true;

        if ('dialogModal' in element.dataset) {
            modal = parseBoolean(element.dataset.dialogModal);
        }

        element.addEventListener('click', () => {
            if (modal) {
                dialog.showModal();
            } else {
                dialog.show();
            }

            if (callback) {
                window[callback]('open');
            }
        }, false);

        dialog.querySelectorAll('[data-dialog-close]').forEach(el => {
            el.addEventListener('click', () => {
                dialog.close();

                if (callback) {
                    window[callback]('close');
                }
            }, false);
        });
    }
}
